/**
 * @generated SignedSource<<02683ae6c4e768f125e25cce9dc22ce1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitScreenRow_sourcePerson$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_sourcePerson" | "PlaceholderSidePanel_sourcePerson">;
  readonly " $fragmentType": "SplitScreenRow_sourcePerson";
};
export type SplitScreenRow_sourcePerson$key = {
  readonly " $data"?: SplitScreenRow_sourcePerson$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitScreenRow_sourcePerson">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitScreenRow_sourcePerson",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanel_sourcePerson"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlaceholderSidePanel_sourcePerson"
    }
  ],
  "type": "people",
  "abstractKey": null
};

(node as any).hash = "b6205b604770e94100435e2975944001";

export default node;
